<template>
  <div class="grid-6 g-32" style="flex-wrap: wrap;">
    <BigImageAndTitleBlock :title="item.name" :image="item.image" :entity="item.entity" :slug="item.slug"
                           v-for="item in items"/>
  </div>
</template>

<script>
import BigImageAndTitleBlock from "@/components/molecules/BigImageAndTitleBlock.vue";

export default {
  props: {
    items: Array
  },
  components: {BigImageAndTitleBlock}
}
</script>
